import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00e6d5cd&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00e6d5cd')) {
      api.createRecord('00e6d5cd', component.options)
    } else {
      api.reload('00e6d5cd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=00e6d5cd&", function () {
      api.rerender('00e6d5cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/header-aside/components/header-chat/index.vue"
export default component.exports